const API_HOST = 'http://127.0.0.1:8000/';
export const API_LOGIN = API_HOST + "api/auth/login";
export const API_SIGN_UP = API_HOST + "api/auth/signup";
export const API_KANBAN_ALL =  API_HOST + "api/kanban/all";
